<i18n
  src="@/locales/views/organization/partners/producers/new_crop_field.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="org_partners_producers_show_producer_path"
    :params="{
      organization_id: organization_id,
      producer_id: producer_id
    }"
  />
  <bread-crumbs
    :labels="[module_name, producer?.organization_producer?.producer_code]"
  ></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <template v-if="load_general_data">
    <producer-info :producer="producer" :organization_id="organization_id" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{
                    $t(
                      "model.crop_field.organization_crop_field.crop_field_code"
                    )
                  }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="organization_crop_field.crop_field_code"
                    :class="[
                      'input-text',
                      isInvalid('organization_crop_field.crop_field_code')
                    ]"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.name") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="name"
                    :class="['input-text', isInvalid('name')]"
                  />
                </div>
              </div>
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.hectares") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="hectares"
                    :class="['input-text', isInvalid('hectares')]"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.square_meters") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="square_meters"
                    :class="['input-text', isInvalid('square_meters')]"
                  />
                </div>
              </div>
              
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.crop_field_type_id") }}
                </label>
                <div class="mt-1">
                  <radio-form
                    v-model="crop_field_type_id"
                    name="crop_field_type_id"
                    :options="cropFieldTypes"
                  />
                </div>
              </div>
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" v-if="crop_field_type_id == 1">            
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.planting_date") }}
                </label>
                <div class="mt-1">
                  <date-form v-model="planting_date" mode="month" />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.harvest_time") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="harvest_time"
                    :class="['input-text', isInvalid('harvest_time')]"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.crop_id") }}
                </label>
                <div class="mt-1">
                  <select-form
                    :options="crops"
                    v-model="crop_id"
                    label="name"
                    :is_invalid="isInvalidSelect('crop')"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.crop_variety_id") }}
                </label>
                <div class="mt-1">
                  <select-form
                    :options="crop_varieties"
                    v-model="crop_variety_id"
                    label="name"
                    :is_invalid="isInvalidSelect('crop_variety')"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.tree_number") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="tree_number"
                    :class="['input-text', isInvalid('tree_number')]"
                  />
                </div>
              </div>
              
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.location") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="location"
                    :class="['input-text', isInvalid('location')]"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.longitude_dd") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="longitude_dd"
                    :class="['input-text', isInvalid('longitude_dd')]"
                  />
                  <em class="text-sm">Ejemplo: -80.701825</em>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.latitude_dd") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="latitude_dd"
                    :class="['input-text', isInvalid('latitude_dd')]"
                  />
                  <em class="text-sm">Ejemplo: -5.192999</em>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.longitude_dms") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="longitude_dms"
                    :class="['input-text', isInvalid('longitude_dms')]"
                  />
                  <em class="text-sm">Ejemplo: 80º 42' 6.57'' O</em>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.latitude_dms") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="latitude_dms"
                    :class="['input-text', isInvalid('latitude_dms')]"
                  />
                  <em class="text-sm">Ejemplo: 5º 11' 34.8'' S</em>
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.crop_field.altitude") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.trim="altitude"
                    :class="['input-text', isInvalid('altitude')]"
                  />
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="goToShowProducer()"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <success-button
              v-if="!proc_save_button"
              @click.prevent="create()"
              :label="$t('labels.save_button')"
            />
            <success-button-processing
              v-else
              :label="$t('labels.save_button')"
            />
          </div>
        </div>
      </div>
    </div>
  </template>

  <loading-message v-else />
</template>

<script>

import CropFieldTypesMixin from "@/components/views/mixins/organization/partners/producers/crop_field_types.js";

import Requester from "@/views/organization/requesters/partners/producers/manage_crop_field.js";
import RequesterManageProducer from "@/views/organization/requesters/partners/producers/manage_producer.js";
import ProducerInfo from "@/components/views/organization/partners/producers/ProducerInfo.vue";

export default {
  name: "OrgPartnersProducersNewCropField",
  mixins: [CropFieldTypesMixin],
  components: { ProducerInfo },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      producer: {},
      crops: [],
      crop_varieties: [],
      organization_crop_field: { crop_field_code: null },
      name: null,
      hectares: null,
      square_meters: null,
      longitude_dd: null,
      latitude_dd: null,
      longitude_dms: null,
      latitude_dms: null,
      altitude: null,
      location: null,
      planting_date: null,
      harvest_time: null,
      tree_number: null,
      crop_id: null,
      crop_variety_id: null,
      crop_field_type_id: 1
    };
  },
  props: {
    organization_id: {},
    producer_id: {}
  },
  methods: {
    loadData: async function () {
      await this.fetchProducer();
      await this.fetchCrops();
      this.load_general_data = true;
    },
    fetchProducer: async function () {
      let response = await RequesterManageProducer.fetchProducer(
        this.organization_id,
        this.producer_id
      );

      this.producer = response.data;
    },
    fetchCrops: async function () {
      let response = await Requester.fetchCrops(this.organization_id);

      this.crops = response.data;
    },
    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.createCropField(
          this.organization_id,
          this.producer_id,
          {
            name: this.name,
            hectares: this.hectares,
            square_meters: this.square_meters,
            longitude_dd: this.longitude_dd,
            latitude_dd: this.latitude_dd,
            longitude_dms: this.longitude_dms,
            latitude_dms: this.latitude_dms,
            altitude: this.altitude,
            location: this.location,
            planting_date: this.planting_date,
            harvest_time: this.harvest_time,
            tree_number: this.tree_number,
            crop_id: this.crop_id,
            crop_variety_id: this.crop_variety_id,
            crop_field_type_id: this.crop_field_type_id,
            organization_crop_field: {
              crop_field_code: this.organization_crop_field.crop_field_code
            }
          }
        );

        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProducer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
        this.proc_save_button = false;
      }
    },
    goToShowProducer: function () {
      this.$router.push({
        name: "org_partners_producers_show_producer_path",
        params: {
          organization_id: this.organization_id,
          producer_id: this.producer_id
        }
      });
    }
  },
  watch: {
    crop_id: function () {
      this.crop_variety_id = null;
      this.crop_varieties =
        this.crops.find(crop => crop.id == this.crop_id)?.crop_varieties || [];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
